import { Helmet } from "react-helmet-async";

/**
 * Injects Google Search Console + Bing Webmaster verification meta tags
 * from environment variables. Mounted globally in App so it's on every page.
 *
 * To activate:
 *  1. Visit https://search.google.com/search-console → Add Property → choose "HTML tag"
 *     method → copy the content="..." value into REACT_APP_GOOGLE_SITE_VERIFICATION
 *  2. Visit https://www.bing.com/webmasters → Add Site → choose "Meta tag" method
 *     → copy the content="..." value into REACT_APP_BING_SITE_VERIFICATION
 *  3. Click "Redeploy" in Emergent. Both consoles auto-verify within minutes.
 *  4. Submit sitemap https://resumelab.co.ke/sitemap.xml inside each console.
 */
export default function SiteVerification() {
  const google = process.env.REACT_APP_GOOGLE_SITE_VERIFICATION;
  const bing = process.env.REACT_APP_BING_SITE_VERIFICATION;
  if (!google && !bing) return null;
  return (
    <Helmet>
      {google ? <meta name="google-site-verification" content={google} /> : null}
      {bing ? <meta name="msvalidate.01" content={bing} /> : null}
    </Helmet>
  );
}
